import { getRbacMissingPermissions } from '~/utils/rbacErrors'

/**
 * Règle de nouvel essai par défaut des requêtes (`QueryClient` de `main.tsx`) : trois essais de plus,
 * sauf sur un refus RBAC, déterministe, que réessayer ne pourrait que répéter. Une requête qui a ses
 * propres refus définitifs la compose plutôt que de la recopier.
 */
export const defaultQueryRetry = (failureCount: number, error: unknown) =>
  getRbacMissingPermissions(error) === null && failureCount < 3
